import OfficerService from '../../services/OfficerService.js'

export const namespaced = true

export const state = {
  officers: [],
  officer: {}
}

export const mutations = {
  ADD_OFFICER(state, officer) {
    state.officers.push(officer)
  },
  SET_OFFICERS(state, officers) {
    state.officers = officers
  },
  SET_OFFICER(state, officer) {
    state.officer = officer
  },
  UPDATE_OFFICER(state, officer) {
    state.officers = [...state.officers.filter(o => o.officerID !== officer.officerID), officer]
  },
  DELETE_OFFICER(state, id) {
    state.officers = [...state.officers.filter(o => o.officerID !== id)]
  }
}

export const actions = {
  save({ commit }, officer) {
    if (officer.officerID) {
      return OfficerService.put(officer).then(res => {
        const o = res.data
        commit('UPDATE_OFFICER', o)
        commit('SET_OFFICER', o)
      })
    } else {
      return OfficerService.post(officer).then(res => {
        const o = res.data
        commit('ADD_OFFICER', o)
        commit('SET_OFFICER', o)
      })
    }
  },
  delete({ commit }, id) {
    return OfficerService.delete(id).then(() => {
      commit('DELETE_OFFICER', id)
    })
  },
  getByEntity({ commit }, id) {
    return OfficerService.getByEntity(id).then(res => {
      commit('SET_OFFICERS', res.data)
    })
  },
  set({ commit }, id) {
    return new Promise((resolve, reject) => {
      const officer = state.officers.find(o => o.officerID == id)
      if (!officer) return reject()
      commit('SET_OFFICER', officer)
      resolve(officer)
    })
  },
  clearOfficer({ commit }) {
    return new Promise(resolve => {
      commit('SET_OFFICER', {})
      resolve()
    })
  },
  clear({ commit }) {
    return new Promise(resolve => {
      commit('SET_OFFICER', {})
      commit('SET_OFFICERS', [])
      resolve()
    })
  },
  saveDocument({ commit, dispatch }, document) {
    return OfficerService.saveDocument(document).then(res => {
      const o = res.data.officer
      const d = res.data.document
      commit('ADD_OFFICER', o)
      commit('SET_OFFICER', o)
      return dispatch('document/add', d, { root: true })
    })    
  },
  setOfficers({ commit }, officers) {
    return new Promise(resolve => {
      commit('SET_OFFICERS', officers)
      resolve()
    })
  }
}

export const getters = {
  officersForEntity: (state, getters, rootState) => state.officers.filter(o => o.entityID == rootState.entity.entity.entityID).sort((a, b) => a.officerID - b.officerID)
}